import timeago from 'timeago.js';
import responsiveSwipeItem from './responsiveSwipeItem';
import du from '../utils/dom-utilities';

/**
 * return the current language
 */
const getDocumentLang = () => {
    const html = document.querySelector('html');

    if (!html) {
        return;
    }

    const lang = html.getAttribute('lang');

    if (!lang) {
        return 'en';
    }
    return lang.substring(0, 2);
};


/**
 * Load the selected language for timeago plugin.
 * @param {*} number
 * @param {*} index
 */
const localeFR = (number, index) => {
    return [
        ['à l\'instant', 'dans un instant'],
        ['il y a %s secondes', 'dans %s secondes'],
        ['il y a 1 minute', 'dans 1 minute'],
        ['il y a %s minutes', 'dans %s minutes'],
        ['il y a 1 heure', 'dans 1 heure'],
        ['il y a %s heures', 'dans %s heures'],
        ['il y a 1 jour', 'dans 1 jour'],
        ['il y a %s jours', 'dans %s jours'],
        ['il y a 1 semaine', 'dans 1 semaine'],
        ['il y a %s semaines', 'dans %s semaines'],
        ['il y a 1 mois', 'dans 1 mois'],
        ['il y a %s mois', 'dans %s mois'],
        ['il y a 1 an', 'dans 1 an'],
        ['il y a %s ans', 'dans %s ans']
    ][index];
};

/**
 * Remove focus on elements when page is not in foreground
 * @param {*} el Required. Element affected by focus out if page is in background
 */
function removeFocusWhenTabOpened(el) {
    let visibilityChange;

    if (typeof document.hidden !== 'undefined') {
        visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
        visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
        visibilityChange = 'webkitvisibilitychange';
    }

    du.onEvent(document, visibilityChange, () => {
        if (document.hidden && el.contains(document.activeElement)) {
            document.activeElement.blur();
        }
    });
}

export default class LastTweet {
    constructor() {
        this.url = '/o/rest/twitter/latest/';
        this.render = document.querySelector('.last-tweet-list__items');
    };

    init() {
        if (!this.render) {
            return;
        }
        this.get()
            .then((data) => {
                if (data.length === 0) {
                    Promise.reject('Last tweet response is empty');
                }
                var tweet;
                var tweetCard;

                timeago.register('fr', localeFR);
                const timeagoInstance = timeago();

                for (tweet in data) {
                    if (data[tweet].extendedMediaEntities[0]
                        && data[tweet].extendedMediaEntities[0].mediaURLHttps) {
                        tweetCard = this.createMediaTweet(data[tweet], tweet, timeagoInstance);
                    } else {
                        tweetCard = this.createTweet(data[tweet], tweet, timeagoInstance);
                    }
                    this.render.innerHTML += tweetCard;
                }
            })
            .then(() => {
                const tweets = du.queryAll('.last-tweet', this.render);
                responsiveSwipeItem('data-responsive-swipe-tweet');
                du.hoverOnScrollForMobile(tweets, 'last-tweet--hover');
                removeFocusWhenTabOpened(this.render);
            })
            .catch((error) => {
                console.error('Something went wrong with this request', error);
            });

    }
    get() {
        return fetch(this.url, {credentials: 'include'})
            .then(response => response.json())
            .then(data => {
                const lastTweet = data;

                if (lastTweet && lastTweet.length > 0) {
                    return lastTweet;
                }
            })
            .catch(error => {
                console.error('[GET] Something went wrong with request', error);
            });
    }

    /**
     * Take a stringified json and return a last-tweet video or image html element
     * @param {String} tweet - The raw response of api
     * @param {String} index - Index of the current tweet
     * @param {String} timeagoInstance - an instance of timeago with the correct language loaded
     */
    createMediaTweet(tweet = null, index, timeagoInstance) {
        if (!tweet) {
            return;
        }
        tweet.text = this.ellipsisText(tweet.text);
        tweet.text = this.getMentions(tweet.text, tweet.userMentionEntities);
        tweet.text = this.getHashtags(tweet.text);
        tweet.text = this.getUrls(tweet.text);

        var tweetType = null;
        if (tweet.extendedMediaEntities[0].type === 'photo') {
            tweetType = 'last-tweet--with-image';
        } else {
            tweetType = 'last-tweet--with-video';
        }
        var tweetThumb;
        if (tweet.extendedMediaEntities[0].sizes) {
            tweetThumb = tweet.extendedMediaEntities[0].mediaURLHttps +  ':medium';
        }
        return `
            <a href="${tweet.tweetURL}" target="_blank" class="last-tweet last-tweet__item ${tweetType}">
                <div class="last-tweet__image" style="background-image: url(${tweetThumb});
                background-size: cover; background-position: center center;">
                    <div class="last-tweet__overlay">
                        <svg class="ico ico--round-play">
                            <use xlink:href="#round-play"/>
                        </svg>
                    </div>
                </div>
                <span class="last-tweet__card"></span>
                <div class="last-tweet__mask">
                    <div class="last-tweet__info">
                        <div class="last-tweet-header">
                            <svg class="ico ico--time"><use xlink:href="#time"/></svg>
                            <span>${timeagoInstance.format(tweet.createdAt, getDocumentLang())}</span>
                        </div>
                        <p class="last-tweet-content">${tweet.text}</p>
                        <svg class="ico ico--round-go last-tweet__icon last-tweet-footer">
                            <use xlink:href="#round-go"/>
                        </svg>
                    </div>
                </div>
            </a>
        `;
    }

    /**
     * Take a stringified json and return a last-tweet html element
     * @param {String} tweet - The raw response of api
     * @param {String} index - Index of the current tweet
     * @param {String} timeagoInstance - an instance of timeago with the correct language loaded
     */
    createTweet(tweet = null, index, timeagoInstance) {
        if (!tweet) {
            return;
        }
        tweet.text = this.ellipsisText(tweet.text);
        tweet.text = this.getMentions(tweet.text, tweet.userMentionEntities);
        tweet.text = this.getHashtags(tweet.text);
        tweet.text = this.getUrls(tweet.text);

        var tweetStyle;
        if (index === '0' || index === '4') {
            tweetStyle = 'last-tweet-delta';
        } else if (index === '2' || index === '5') {
            tweetStyle = 'last-tweet-gamma';
        }

        var tweetLabel = 'See it on our Twitter account';
        if (document.querySelector('.js-last-tweet-label')
            && document.querySelector('.js-last-tweet-label').innerText) {
            tweetLabel = document.querySelector('.js-last-tweet-label').innerText;
        }

        return `
            <a href="${tweet.tweetURL}" target="_blank" class="last-tweet last-tweet__item ${tweetStyle}">
                <span class="last-tweet__card"></span>
                    <div class="last-tweet__container">
                        <div class="last-tweet-header">
                            <svg class="ico ico--time"><use xlink:href="#time"/></svg>
                            <span>${timeagoInstance.format(tweet.createdAt, getDocumentLang())}</span>
                        </div>
                        <p class="last-tweet-content">${tweet.text}</p>
                    </div>
                <div class="last-tweet__mask">
                    <div class="last-tweet__info last-tweet-footer">
                        <span class="last-tweet__label">${tweetLabel}</span>
                        <svg class="ico ico--round-go last-tweet__icon">
                            <use xlink:href="#round-go"/>
                        </svg>
                    </div>
                </div>
            </a>
        `;
    }

    /**
     * Parse a string and reduce text size
     * @param {String} msg - a tweet
     * @param {Number} max - max number of char
     */
    ellipsisText(msg = null, max = 163) { // 160 + 3 for the ellipsis
        if (!msg) {
            return;
        }

        if (msg.length > max) {
            return msg.substring(0, (max - 3)) + '...';
        } else {
            return msg;
        }
    }

    /**
     * Parse a string and return it with mentions enclosed by <span></span>
     * @param {String} msg - a tweet
     * @param {String} mentions - a list of mentions
     */
    getMentions(msg = null, mentions = null) {
        if (!msg) {
            return;
        }

        if (mentions) {
            const mentionsList = mentions.map((mention) => mention.screen_name).join('|');
            const pattern = '\@(' + mentionsList + ')\\b';
            let final = msg.replace(new RegExp(pattern, 'gi'), '<span class="last-tweet__hashtag">@$1</span>');

            return final;
        }
    }

    /**
     * Parse a string and return it with hashtags enclosed by <span></span>
     * @param {String} msg - a tweet
     */
    getHashtags(msg = null) {
        if (!msg) {
            return;
        }

        const hashWithHtml = msg.replace(/(^|\W)(#[a-z\d][\wœáéíóäëiöúàèììù-]*)/ig,
            " <span class='last-tweet__hashtag'>$2</span>");
        return hashWithHtml;
    }

    /**
     * Parse a string and return it with url enclosed by <span></span>
     * @param {String} msg - a tweet
     */
    getUrls(msg = null) {
        if (!msg) {
            return;
        }

        const msgWithUrls = msg.replace(/((http|https|www)\b:\/\/(\w[.,\/]?)+)/ig,
            " <span class='last-tweet__hashtag'>$1</span>");

        return msgWithUrls;
    }
};



// WEBPACK FOOTER //
// ./src/main/js/components/twitter.js